<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ 'choose_roles' | translate: lang }} {{ ((game === 'lol' || game === 'wild-rift') && type === 'solo' ? '&_summoner_spells' : '') | translate: lang }}</h5>
  <button (click)="closeWithoutSelectedData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
      <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>

<div class="modal-body text-center">
  <div class="row">
    <div class="role-selector">
      <div class="role {{game}}">
        <h6>{{ 'select_main_role' | translate: lang }}</h6>

        <div class="icons">
          <div class="icon-btn" *ngFor="let role of roles" [class.active]="selectedPrimaryRole === role">
            <img
              [attr.src]="getImageUrl(role, (selectedPrimaryRole === role ? 'white' : gameColor[game]))"
              (click)="toggleRole('primary', role)"
              alt="{{ game + ' ' + role + ' icon'}}"
              title="{{ role | titlecase }}"
            >
          </div>
        </div>

      </div>

      <div class="role {{game}} margin-top">
        <h6>{{ 'select_secondary_role' | translate: lang }}</h6>

        <div class="icons">
          <div class="icon-btn" *ngFor="let role of roles" [class.active]="selectedSecondaryRole === role">
            <img
              [attr.src]="getImageUrl(role, (selectedSecondaryRole === role ? 'white' : gameColor[game]))"
              (click)="toggleRole('secondary', role)"
              alt="{{ game + ' ' + role + ' icon'}}"
              title="{{ role | titlecase }}"
            >
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="row">
    <div *ngIf="(game === 'lol' || game ==='wild-rift') && type === 'solo'">
      <h6>{{ 'select_summoner_spell_keyset' | translate: lang }}</h6>
      <div class="keysets">
        <div class="keyset" [class.active]="keySet === 2" [ngClass]="game ? game : ''" (click)="keySet = 2">
          <div class="keyset-elem">
            <img src="https://cdn.ggboost.com/images/spells/4.png" alt="">
            <p *ngIf="game === 'lol'">D</p>
            <p *ngIf="game === 'wild-rift'"><</p>
          </div>
        </div>
        <div class="keyset" [class.active]="keySet === 1" [ngClass]="game ? game : ''" (click)="keySet = 1">
          <div class="keyset-elem">
            <img src="https://cdn.ggboost.com/images/spells/4.png" alt="">
            <p *ngIf="game === 'lol'">F</p>
            <p *ngIf="game === 'wild-rift'">></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-button size="form" [block]="true" (clicked)="onSelect()">{{ 'confirm' | translate: lang }}</app-button>
</div>